const IconFrame = ({ children, className = "" }) => (
  <svg
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
  >
    {children}
  </svg>
);

export const ProtocolIcon = ({ kind, className = "" }) => {
  const shared = {
    stroke: "currentColor",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round",
  };

  if (kind === "morning") {
    return (
      <IconFrame className={className}>
        <path d="M7 29.5H33M11 25.5H29" {...shared} />
        <path d="M13.5 25.5a6.5 6.5 0 0 1 13 0" {...shared} />
        <path d="M20 8v4M10.8 12.3l2.8 2.8M29.2 12.3l-2.8 2.8M7 20h4M29 20h4" {...shared} />
        <circle cx="20" cy="20" r="1.4" fill="currentColor" />
      </IconFrame>
    );
  }

  if (kind === "chill") {
    return (
      <IconFrame className={className}>
        <path d="M20 6v28M7.9 13l24.2 14M7.9 27l24.2-14" {...shared} />
        <path d="m16.8 9.2 3.2 3.2 3.2-3.2M16.8 30.8l3.2-3.2 3.2 3.2M9.8 16.8l4.3.9-1.3-4.2M30.2 23.2l-4.3-.9 1.3 4.2M9.8 23.2l4.3-.9-1.3 4.2M30.2 16.8l-4.3.9 1.3-4.2" {...shared} />
        <circle cx="20" cy="20" r="2" fill="currentColor" />
      </IconFrame>
    );
  }

  if (kind === "five") {
    return (
      <IconFrame className={className}>
        <rect x="7.5" y="9.5" width="25" height="23" {...shared} />
        <path d="M7.5 15.5h25M13 6.5v6M27 6.5v6" {...shared} />
        {[12, 16, 20, 24, 28].map((x) => <circle key={x} cx={x} cy="22" r="1.35" fill="currentColor" />)}
        <path d="M12 27.5h16" {...shared} />
      </IconFrame>
    );
  }

  return (
    <IconFrame className={className}>
      <path d="M5.5 21h6l3.7-10 7.1 18 4.1-11 2.6 3h5.5" {...shared} />
      <circle cx="15.2" cy="11" r="1.8" fill="currentColor" />
      <circle cx="22.3" cy="29" r="1.8" fill="currentColor" />
      <circle cx="26.4" cy="18" r="1.8" fill="currentColor" />
      <path d="M8 9.5h3M9.5 8v3M30 29h3M31.5 27.5v3" {...shared} />
    </IconFrame>
  );
};